import { products } from "./productReducer";

export default products;